import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import { useNotification } from "~hooks/useNotification.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

const useDeleteEntity = () => {
  const { sport, organizationId } = useParams();
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const request = useApi();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (entityId: string) => {
      return await request(`${sport}/o/${organizationId}/entities/${entityId}`, { method: "DELETE" });
    },
    onSuccess: (response: DefaultOperationSuccessResponse) => {
      if (response?.data[0]?.success) {
        notification.success({
          message: formatMessage({ id: "entity.delete.success" }),
          placement: "bottomRight",
        });
        queryClient.invalidateQueries({ queryKey: ["entities"] });
      }
    },
  });
};

export default useDeleteEntity;
